import React from 'react';
import Layout from '../../components/Layout';
import { MARKETING_NAV_LINKS } from '../../constants';
import Privacy from './Privacy';

function action() {
  return {
    chunks: ['marketing'],
    title: 'Legal',
    component: (
      <Layout transitionId="privacy" showHeader={true}>
        <Privacy />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/privacy/index.js